import React, { useEffect } from 'react';
import PageScrollTop from '../../utils/PageScrollTop';
import { Container, Row, Col } from 'react-bootstrap';
import { ComplianceProgramContent } from './ComplianceProgramContent';
import { StyledPolicies } from './styles/StyledPolicies';
import Layout from '../../partials/Layout';

const ComplianceProgram = () => {
  useEffect(() => {
    document.title = 'Terms of Service';
  }, []);

  return (
    <Layout>
      <PageScrollTop>
        <StyledPolicies className="tco">
          <Container className="tco-s-1 pt-xs-2p5 pt-md-2p5 pb-xl-10">
            <Row>
              <Col className="pb-5" xs={12} xl={4}>
                <h3 className="pb-3 toUpperCase">
                  <strong>Atlantic Labs, LLC</strong>
                </h3>
                <h2 className="pb-5">
                  <strong>Corporate Compliance Program Policy Statement</strong>
                </h2>
                <p className="fc-primary_medium">
                  <small className="fw-500">Last Revision: 20-Aug-2021</small>
                </p>
              </Col>
              <Col className="" xs={12} xl={{ span: 6, offset: 1 }}>
                {ComplianceProgramContent.map(text => {
                  return (
                    <>
                      {text.title && <h3 className={`${text?.paragraphs ? 'pb-xs-1p0 pb-md-2p0' : 'pb-5'}`}>{text.title}</h3>}
                      {text?.paragraphs &&
                        text.paragraphs.map(p => {
                          return <p className="pb-2p0">{p}</p>;
                        })}
                    </>
                  );
                })}
              </Col>
            </Row>
          </Container>
        </StyledPolicies>
      </PageScrollTop>
    </Layout>
  );
};

export default ComplianceProgram;
